import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./breadcrumb.css";

type BreadcrumbProps = {
  clickCurrent?: boolean;
};

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ clickCurrent = false }) => {
  const location = useLocation();

  const pathnames = location.pathname.split("/").filter((x) => x);
  const hash = location.hash.replace("#", "");

  const normalizedPath = location.pathname.toLowerCase();

  if (normalizedPath === "/" || normalizedPath === "/company" || normalizedPath === "/industries") {
    return null;
  }

  const labelMap: Record<string, string> = {
    "viksit-bharat": "viksitbharat#2047",
    "isr-systems": "ISR Systems",
    "products": "Products",
    "services": "Services",
    "industries": "Industries"
  };



  return (
    <nav aria-label="breadcrumb" className="breadcrumb-container">
      <ol className="breadcrumb-list">

        <li className="breadcrumb-item">
          <Link to="/" className="breadcrumb-link">Home</Link>
        </li>

        {pathnames.map((name, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
          const isLast = index === pathnames.length - 1;

          let label = labelMap[name] ?? decodeURIComponent(name);

         

          // 🔹 Existing hash override logic
          if (isLast && hash && labelMap[hash]) {
            label = labelMap[hash];
          }

          return (
            <li key={routeTo} className="breadcrumb-item">
              <span className="breadcrumb-separator">›</span>

              {isLast && !clickCurrent ? (
                <span className="breadcrumb-current">{label}</span>
              ) : (
                <Link to={routeTo + (hash ? `#${hash}` : "")} className="breadcrumb-link">
                  {label}
                </Link>
              )}

            </li>
          );
        })}

      </ol>
    </nav>
  );
};

export default Breadcrumb;
